import React, { useEffect } from "react";
// import hero_image_5 from "../../assets/images/hero_image_5.jpg";
import projects from "../../assets/icons/projects.png";
import awards from "../../assets/icons/awards.png";
import reviews from "../../assets/icons/reviews.png";
import customers from "../../assets/icons/customers.png";
import AOS from 'aos';
import "./Reviews.css";

export default function Reviews() {
  useEffect(() => {
    AOS.init({ duration: 700, delay: 800 });
  }, []);
  return (
    <div
      className="Reviews padding_top_bottom"
      // style={{ backgroundImage: `url(${hero_image_5})` }}
    >
      {/* <div className="dark_layer"></div> */}
      <div className="container">
        <div className="section_reviews row">
          <div data-aos="fade-up" className="review_item layout-col-md-6 layout-col-lg-3 layout-col-sm-12">
            <img src={projects} alt="projects" />
            <h1>120</h1>
            <p>PROJECTS</p>
          </div>
          <div data-aos="fade-up" className="review_item layout-col-md-6 layout-col-lg-3 layout-col-sm-12">
            <img src={awards} alt="Awards" />
            <h1>30</h1>
            <p>AWARDS</p>
          </div>
          <div data-aos="fade-up" className="review_item layout-col-md-6 layout-col-lg-3 layout-col-sm-12">
            <img src={reviews} alt="Positive Reviews" />
            <h1>99%</h1>
            <p>POSITIVE REVIEWS</p>
          </div>
          <div data-aos="fade-up" className="review_item layout-col-md-6 layout-col-lg-3 layout-col-sm-12">
            <img src={customers} alt="Happy Customers" />
            <h1>12</h1>
            <p>HAPPY CUSTOMERS</p>
          </div>
        </div>
      </div>
    </div>
  );
}
